"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tab_1 = __importDefault(require("@react/web/Common/Tabs/Tab"));
const Tabs_1 = __importDefault(require("@react/web/Common/Tabs/Tabs"));
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
const FixtermBoxView_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/views/FixtermBoxView"));
const FlexibleBoxView_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/views/FlexibleBoxView"));
const MintermBoxView_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/views/MintermBoxView"));
const PriceView_1 = require("@react/web/Common/Price/PriceView");
const useSubscriptionListing_1 = require("@react/web/Listing/hooks/useSubscriptionListing");
function getServices(mileageYearlyOptionsData) {
    var _a;
    if (mileageYearlyOptionsData === null) {
        return '';
    }
    const activeMileage = (_a = mileageYearlyOptionsData.filter((mileage) => mileage.active)[0]) !== null && _a !== void 0 ? _a : null;
    if (activeMileage === null) {
        return '';
    }
    let services;
    const isDrivetoCar = PageHelper_1.PageHelper.isDrivetoCar();
    const publicNoteServices = PageHelper_1.PageHelper.getPublicNoteServices();
    if (isDrivetoCar === false && publicNoteServices.length !== 0) {
        services = publicNoteServices;
    }
    else {
        services = activeMileage.services;
    }
    let items = '';
    services.forEach((item) => {
        items += `<li>${isDrivetoCar === false && item === 'Havarijní poj. 5% (min. 5000 Kč)' ? 'Havarijní pojištění' : item}</li>`;
    });
    return items;
}
function getAvailableOffersTabs(availableOffers, mileageYearlyOptionsData, handleContractLengthChange, contractLengthOptions) {
    const children = [];
    if (availableOffers === null) {
        return children;
    }
    if (availableOffers.flexible !== null) {
        children.push(react_1.default.createElement(Tab_1.default, { key: `tab-${PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE}`, title: `<span class="title">Vraťte kdykoliv</span> ${(0, PriceView_1.PriceViewString)(availableOffers.flexible.monthlyPrice, false)}`, tabName: PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE },
            react_1.default.createElement(FlexibleBoxView_1.default, { flexibleOffer: availableOffers.flexible, services: getServices(mileageYearlyOptionsData) })));
    }
    if (availableOffers.minterm !== null) {
        children.push(react_1.default.createElement(Tab_1.default, { key: `tab-${PageHelper_1.InquiryOfferTypesEnum.MINTERM}`, title: `<span class="title">Minimálně na 6&nbsp;měsíců</span> ${(0, PriceView_1.PriceViewString)(availableOffers.minterm.monthlyPrice, false)}`, tabName: PageHelper_1.InquiryOfferTypesEnum.MINTERM },
            react_1.default.createElement(MintermBoxView_1.default, { mintermOffer: availableOffers.minterm, services: getServices(mileageYearlyOptionsData) })));
    }
    if (availableOffers.fixterm !== null) {
        let priceFromLabel = '';
        if (contractLengthOptions && contractLengthOptions.length > 0) {
            const isPriceDifferent = contractLengthOptions.filter((contractLength) => contractLength.price.withoutVat !== contractLengthOptions[0].price.withoutVat).length > 0;
            const priceFrom = [...contractLengthOptions].sort((a, b) => a.price.withoutVat - b.price.withoutVat)[0].price;
            priceFromLabel = (0, PriceView_1.PriceViewString)(priceFrom, isPriceDifferent === true);
        }
        children.push(react_1.default.createElement(Tab_1.default, { key: `tab-${PageHelper_1.InquiryOfferTypesEnum.FIXTERM}`, title: `<span class="title">Na dobu určitou</span> ${priceFromLabel}`, tabName: PageHelper_1.InquiryOfferTypesEnum.FIXTERM },
            react_1.default.createElement(FixtermBoxView_1.default, { contractLengthOptions: contractLengthOptions, fixtermOffer: availableOffers.fixterm, handleContractLengthChange: handleContractLengthChange, services: getServices(mileageYearlyOptionsData) })));
    }
    return children;
}
const OfferDetailPriceOffersTab = ({ currentPriceOfferType, contractLengthOptions, availableOffers, handleContractLengthChange, handleTabChange, mileageYearlyOptionsData, }) => react_1.default.createElement("div", { className: "price-offers-tabs-container" },
    useSubscriptionListing_1.isDealFlexibleEnabled === true
        && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "section-label" }, "Varianty pron\u00E1jmu"),
            react_1.default.createElement("div", { className: "offer-variants-tabs" },
                react_1.default.createElement(Tabs_1.default, { selectedTabName: currentPriceOfferType, handleTabChange: handleTabChange }, getAvailableOffersTabs(availableOffers, mileageYearlyOptionsData, handleContractLengthChange, contractLengthOptions)))),
    useSubscriptionListing_1.isDealFlexibleEnabled === false
        && react_1.default.createElement("div", { className: "offer-variants-tabs" }, availableOffers !== null && availableOffers.fixterm !== null
            && react_1.default.createElement(FixtermBoxView_1.default, { contractLengthOptions: contractLengthOptions, fixtermOffer: availableOffers.fixterm, handleContractLengthChange: handleContractLengthChange, services: getServices(mileageYearlyOptionsData) })));
exports.default = OfferDetailPriceOffersTab;
